import { ReactElement } from 'react';

import { PractitionerDetails, PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';
import { Practitioner as WaitlistPractitioner } from '@dreryk/egabinet-waitlist-frontend-api';

import { Select } from '@dreryk/react-components';
import { BindingCreator, createTranslatedText } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';
import { formatPractitioner } from '../../../shared/formatPractitioner';

type PractitionerFormBeanPart = {
   practitioner?: WaitlistPractitioner | PractitionerView | null;
};

type PractitionerFieldProps = {
   register: BindingCreator<PractitionerFormBeanPart>;
   practitioners?: PractitionerView[];
   currentPractitioner?: PractitionerDetails;
};

export const PractitionerField = (props: PractitionerFieldProps): ReactElement => {
   return (
      <Select<WaitlistPractitioner>
         testId={'practitioner'}
         controller={props.register('practitioner', { required: true })}
         label={translationKeys.specialist}
         triggerLabelExtractor={formatPractitioner}
         placeholder={translationKeys.choosePlaceholder.ellipsified}
         disabled={Boolean(props.currentPractitioner)}
      >
         <Select.List
            items={
               (props.practitioners ?? [props.currentPractitioner]) as Array<PractitionerView | PractitionerDetails>
            }
            keyExtractor={'id'}
         >
            {(item) => (
               <Select.Item testId={item.id} item={item} label={createTranslatedText(formatPractitioner(item))} />
            )}
         </Select.List>
      </Select>
   );
};
